export default __webpack_public_path__ + "static/media/ajw-logo-dark.b40e5dba.svg";